import { ColorService } from '@services/color/color.service';
import * as i0 from "@angular/core";
import * as i1 from "./color.service";
var ChartColorService = /** @class */ (function () {
    function ChartColorService(_colorService) {
        this._colorService = _colorService;
        this.session = [
            this._colorService.getColor('green'),
            this._colorService.getColor('blue'),
            this._colorService.getColor('grey'),
            this._colorService.getColor('red'),
        ];
        this.jobs = [
            this._colorService.getColor('green'),
            this._colorService.getColor('red'),
            this._colorService.getColor('orange'),
        ];
        this.transactions = [
            this._colorService.getColor('blue'),
            this._colorService.getColor('orange'),
            this._colorService.getColor('red'),
            this._colorService.getColor('green'),
        ];
        this.license = [
            this._colorService.getColor('green'),
            this._colorService.getColor('orange'),
            this._colorService.getColor('red'),
            this._colorService.getColor('blue'),
            this._colorService.getColor('orangeDark'),
        ];
    }
    ChartColorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChartColorService_Factory() { return new ChartColorService(i0.ɵɵinject(i1.ColorService)); }, token: ChartColorService, providedIn: "root" });
    return ChartColorService;
}());
export { ChartColorService };
